import {
  FETCH,
  DONE,
  FAIL,
  GET, LIBRARY, CURRENT, TYPES, SET, EDIT, DELETE
} from "../../constants";

import reducerStatuses from "../../status";
import {createReducer, PayloadAction} from "@reduxjs/toolkit";
import {TFetch} from "../../types";
import dayjs from "dayjs";

const initialState: TFetch = {
  library: {
    ...reducerStatuses,
    data: null as any,
  },

  currentLibrary: {
    ...reducerStatuses,
    data: null as any,
  },
};

export default createReducer(initialState, builder =>
  builder
    .addCase(GET + LIBRARY + FETCH, (state) => ({
      ...state,
      library: {
        ...initialState.library,
        loading: true
      }
    }))
    .addCase(GET + LIBRARY + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      library: {
        ...initialState.library,
        success: true,
        data: payload
      }
    }))
    .addCase(GET + LIBRARY + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      library: {
        ...initialState.library,
        failed: true
      }
    }))


    .addCase(GET + LIBRARY + CURRENT + FETCH, (state) => ({
      ...state,
      currentLibrary: {
        ...initialState.currentLibrary,
        loading: true
      }
    }))
    .addCase(GET + LIBRARY + CURRENT + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      currentLibrary: {
        ...initialState.currentLibrary,
        success: true,
        data: payload
      }
    }))
    .addCase(GET + LIBRARY + CURRENT + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      currentLibrary: {
        ...initialState.currentLibrary,
        failed: true
      }
    }))


    .addCase(SET + EDIT + TYPES + FETCH, (state) => ({
      ...state,
      currentLibrary: {
        ...state.currentLibrary,
        loading: true
      }
    }))
    .addCase(SET + EDIT + TYPES + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      currentLibrary: {
        ...initialState.currentLibrary,
        success: true,
        data: state.currentLibrary.data.map((item: any) => item.id === payload.data?.material_id ? {
          ...item, ...payload.data,
          updated_at: dayjs().format('YYYY-MM-DD HH:mm:ss')
        } : item)
      }
    }))


    .addCase(SET + DELETE + TYPES + FETCH, (state) => ({
      ...state,
      currentLibrary: {
        ...state.currentLibrary,
        loading: true
      }
    }))
    .addCase(SET + DELETE + TYPES + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      currentLibrary: {
        ...initialState.currentLibrary,
        success: true,
        data: state.currentLibrary.data.filter((item: any) => item.id !== payload.data.id)
      }
    }))
)